import styled from "styled-components";
import Banner from "common/Banner/Banner";
import Text from "common/Typography/Text";
import { useUser } from "@shared/utils/hooks/misc";
import UpgradeButton from "common/Home/Header/UpgradeButton";
import { useSelector } from "react-redux";
import { selectWorkspace } from "@shared/slices/common.slice";
import { LanguageNameSpaces, WorkspaceType } from "@shared/types";
import { getIsDarkMode } from "utils/misc";
import Flex from "common/Boxes/Flex";
import useMedia from "utils/hooks/useMedia";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";

const FreemiumBanner = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);
  const { user } = useUser();
  const workspace = useSelector(selectWorkspace);
  const isDarkMode = getIsDarkMode();
  const isMobile = useMedia([`(max-width: 650px)`], [true], false);

  if (
    !user?.isFree() ||
    workspace === WorkspaceType.DEMO ||
    user?.is_onboarding
  )
    return null;

  return (
    <BannerWrapper
      innerWrapperStyle={{
        display: "flex",
        justifyContent: isMobile ? "space-between" : "center",
        alignItems: "center",
      }}
      $isDarkMode={isDarkMode}
    >
      <Flex
        $flexDirection={isMobile ? "column" : "row"}
        $alignItems="flex-start"
      >
        <StyledText>{t("banners.free_package")}</StyledText>
        <Text style={{ textAlign: "left" }}>{t("banners.upgrade_now")}</Text>
      </Flex>
      <UpgradeButton style={{ marginLeft: 12 }} />
    </BannerWrapper>
  );
};

export default FreemiumBanner;

const BannerWrapper = styled(Banner)<{ $isDarkMode?: boolean }>`
  background: ${(p) =>
    p.$isDarkMode
      ? "linear-gradient(to right, #1D2A52, #4A7997)"
      : "linear-gradient(to right, #FFFFFF, #EFF4FF 75%, #3E6CFF51)"};
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  @media (max-width: 650px) {
    padding: 12px 24px;
    height: auto;
  }
  @media (max-width: 450px) {
    padding: 12px;
  }
`;
const StyledText = styled(Text)`
  font-weight: ${(p) => p.theme.typography.fontWeights.SEMI_BOLD};
  padding-right: 4px;
  text-align: left;
`;
